export const UserActionsTypes = {
  SET_TOKEN: 'user/SET_TOKEN',
  SET_REFRESH_TOKEN: 'user/SET_REFRESH_TOKEN',
  SET_USER_INFO: 'user/SET_USER_INFO',
  RESET: 'user/RESET',
  SET_LOGIN_ENTRIES: 'user/SET_LOGIN_ENTRIES'
}
